import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { DataTableColumn } from '~components/DataTable/dataTableColumn';

function getRowCompliance(row: object) {
  if (!('compliant' in row) || typeof row.compliant !== 'boolean') {
    return null;
  }

  return row.compliant;
}

export function complianceStatusColumn<TRow extends object>(): DataTableColumn<TRow> {
  return {
    field: 'compliant',
    headerName: t('administration.compliance_document_types.compliance'),
    renderCell: (row) => {
      const compliant = getRowCompliance(row);

      if (compliant === null) {
        return null;
      }

      return (
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 0.5 }}>
          <Box
            sx={{
              bgcolor: compliant ? 'success.main' : 'error.main',
              borderRadius: '50%',
              height: 8,
              width: 8,
            }}
          />

          <Typography variant="body2">
            {compliant
              ? t('administration.compliance_document_types.compliant')
              : t('administration.compliance_document_types.non_compliant')}
          </Typography>
        </Box>
      );
    },
  };
}
